import { PageTitle } from '@procureai/ui-mui';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import { BaseDomain } from '~/common/types';

export interface BasePageTitleProps {
  domain: BaseDomain;
}

export const BasePageTitle = ({ domain }: BasePageTitleProps) => {
  const { t } = useTranslation();

  const title = t(`Base.${domain}.title`);

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <PageTitle title={title}></PageTitle>
    </>
  );
};
